import React from "react";

import { graphql } from "@apollo/client/react/hoc";
import gql from "graphql-tag";

import Loading from "../../loading";

class FetchCollections extends React.Component {
    render() {
        if (!this.props.data || this.props.data.loading) {
            return <Loading />;
        }

        const { userCollections } = this.props.data;
        const collections = userCollections && userCollections.collections;

        return (
            <React.Fragment>
                {React.cloneElement(this.props.children, {
                    collections: collections || [],
                    loadMoreCollections: this.props.loadMoreCollections
                })}
            </React.Fragment>
        );
    }
}

// TODO switch this over to using browseCollectionsByCreator
// noteworthy changes:
// - author -> creator
// - permalink -> url
// - collectionIcons -> iconCollections
const query = gql`
    query userCollections(
        $iconLimit: Int!
        $collectionLimit: Int!
        $userId: ID!
        $offset: Int
    ) {
        userCollections(
            limit: $collectionLimit
            userId: $userId
            offset: $offset
        ) {
            collections {
                id
                name
                permalink
                author {
                    fullName
                    username
                    permalink
                }
                slug
                collectionIcons(limit: $iconLimit) {
                    icons {
                        id
                        term
                        preview_url: previewUrl
                        previewUrl
                        permalink
                        uploader {
                            fullName
                            name: fullName
                            permalink
                        }
                        isActive
                    }
                }
            }
            totalCount
        }
    }
`;

export default graphql(query, {
    options: props => ({
        variables: {
            collectionLimit: props.collectionLimit,
            iconLimit: props.iconLimit,
            userId: props.userId,
            offset: props.offset
        }
    }),
    props({ data }) {
        return {
            data,
            loadMoreCollections() {
                const { totalCount, collections } = data.userCollections;
                if (collections.length >= totalCount) return Promise.resolve();

                return data.fetchMore({
                    variables: {
                        offset: data.userCollections.collections.length
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            userCollections: {
                                ...data.userCollections,
                                collections: [
                                    ...previousResult.userCollections
                                        .collections,
                                    ...fetchMoreResult.userCollections
                                        .collections
                                ]
                            }
                        };
                    }
                });
            }
        };
    }
})(FetchCollections);
